module.exports = __webpack_public_path__ + "why8.webp?2362fd531da6049aae6384a995643758";